import { createContext, useContext } from 'react'
import { TemplateEditorApi } from './useTemplateEditor'

export const TemplateEditorContext = createContext<TemplateEditorApi | null>(null)

export const useTemplateEditorContext = (): TemplateEditorApi => {
    const editor = useContext(TemplateEditorContext)

    if (!editor) {
        throw new Error('useTemplateEditorContext must be used within TemplateEditorContext.Provider')
    }

    return editor
}
